"use client";

import { buildingluxuryimage, flamingoparkimage, greymonimage, kanugaimage, washingtonimage } from "@/lib/images";
import Image from "next/image";

const featuredResidences = [
    {
        title: "309 Greymon Drive El Cid",
        description:
            "A historic structure rebuilt from within. The original presence remains, supported by a fully reworked interior plan and updated systems.",
        image: greymonimage,
    },
    {
        title: "707 Kanuga Dr",
        description:
            "A historic structure rebuilt from within. The original presence remains, supported by a fully reworked interior plan and updated systems.",
        image: kanugaimage,
    },
    {
        title: "3609 Washington Rd",
        description:
            "Charming Southland Park retreat with 3,000 sq ft of living, vaulted ceilings, and an airy veranda with views.",
        image: washingtonimage,
    },
    {
        title: "Flamingo Park",
        description:
            "A historic structure rebuilt from within. The original presence remains, supported by a fully reworked interior plan and updated systems.",
        image: flamingoparkimage,
    },
];

export default function FeaturedResidencesGdrDevelopment() {
    return (
        <section className="w-full bg-black xl:py-24 py-6 xl:px-20 px-6">
            <div className="mx-auto max-w-[1320px]">
                <div className="space-y-3 text-center">
                    <p className="text-sm font-medium uppercase tracking-[0.25em] text-white/60">
                        Featured Residences
                    </p>
                    <h2 className=" text-[20px] font-normal leading-tight text-white md:text-[40px]">
                        Featured Residences Across Florida&apos;s <br/>Most Luxurious
                        Destinations
                    </h2>
                </div>

                <div className="mt-10 flex flex-col xl:gap-18 gap-10 xl:flex-row">
                    {/* LEFT IMAGE (25%) */}
                    <div className="xl:w-[30.6%] w-full">
                        <div
                            className="relative h-full min-h-[360px] overflow-hidden"
                            style={{
                                borderImageSource:
                                    "linear-gradient(180deg, #FFFFFF 0%, rgba(153, 153, 153, 0) 100%)",
                                borderImageSlice: 1,
                            }}
                        >
                            <Image
                                src={buildingluxuryimage}
                                alt="Featured residences overview"
                                fill
                                priority
                                className="rounded-[31px] border border-white/50 object-cover"
                            />
                            <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(180deg,rgba(102,102,102,0)_0%,#000000_100%)]" />
                            <div className="absolute bottom-6 left-6 right-6">
                                <p className="text-2xl font-normal text-white text-center leading-tight">
                                    Building Luxury <br/>Since Decade
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT GRID (75%) */}
                    <div className="grid flex-1 gap-15 md:grid-cols-2 grid-cols-1 xl:w-[69.4%] w-full">
                        {featuredResidences.map((item) => (
                            <div
                                key={item.title}
                                className="flex flex-col"
                            >
                                {/* Gradient border: border-image + radius is unreliable in browsers; 1px gradient pad matches Figma */}
                                <div
                                    className="mb-6 w-full rounded-[31px] p-px xl:w-[348px]"
                                    style={{
                                        background:
                                            "linear-gradient(180deg, #FFFFFF 0%, rgba(153, 153, 153, 0) 100%)",
                                    }}
                                >
                                    <div className="relative h-[307px] w-full overflow-hidden rounded-[30px] bg-black">
                                        <Image
                                            src={item.image}
                                            alt={item.title}
                                            fill
                                            className="object-cover"
                                        />
                                    </div>
                                </div>
                              <div className="xl:max-w-[348px] w-full">
                              <h3 className="text-[24px]  font-bold text-white">
                                    {item.title}
                                </h3>
                                <p className="mt-2 md:text-[20px] text-[18px] leading-[34px] text-white/80">
                                    {item.description}
                                </p>
                              </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

